import { createAction, handleActions } from 'redux-actions'

import client from 'common/util/http'

import { selectBrokerOpId } from 'broker/selectors/auth'
import { valueOrNull } from 'broker/util/helper'

const LOAD_BROKER_PERFORMANCE_STATS = 'LOAD_BROKER_PERFORMANCE_STATS'
const FETCH_BROKER_PERFORMANCE_STATS_BEGIN = 'FETCH_BROKER_PERFORMANCE_STATS_BEGIN'
const FETCH_BROKER_PERFORMANCE_STATS_END = 'FETCH_BROKER_PERFORMANCE_STATS_END'

const loadBrokerPerformanceStats = createAction(LOAD_BROKER_PERFORMANCE_STATS)
const fetchBrokerPerformanceStatsBegin = createAction(FETCH_BROKER_PERFORMANCE_STATS_BEGIN)
const fetchBrokerPerformanceStatsEnd = createAction(FETCH_BROKER_PERFORMANCE_STATS_END)


export function fetchBrokerPerformanceStats() {
  return async (dispatch, getState) => {
    dispatch(fetchBrokerPerformanceStatsBegin())
    const broker_op_id = selectBrokerOpId(getState())
    try {
      const payload = await client.post('broker_performance', {
        data: { broker_op_id }
      })

      dispatch(loadBrokerPerformanceStats({
        stats: payload
      }))
    } finally {
      dispatch(fetchBrokerPerformanceStatsEnd())
    }
  }
}

const makeStats = (payload = {}) => ({
  active_referral_value: valueOrNull(payload.active_assignment_value),
  active_referrals: valueOrNull(payload.active_assignments),
  projected_closes: valueOrNull(payload.projected_closes),
  closes: valueOrNull(payload.closes),
  close_value: valueOrNull(payload.close_value),
  broker_met_percentage: valueOrNull(payload.broker_met_percentage),
  market_met_percentage: valueOrNull(payload.market_met_percentage),
  broker_offer_percentage: valueOrNull(payload.broker_offer_percentage),
  market_offer_percentage: valueOrNull(payload.market_offer_percentage),
  broker_contract_percentage: valueOrNull(payload.broker_contract_percentage),
  market_contract_percentage: valueOrNull(payload.market_contract_percentage),
  broker_closed_percentage: valueOrNull(payload.broker_closed_percentage),
  market_closed_percentage: valueOrNull(payload.market_closed_percentage)
})

const cleanState = (payload = {}) => ({
  stats: makeStats(payload.stats),
  loading: false
})

export default handleActions({
  [LOAD_BROKER_PERFORMANCE_STATS]: (state, { payload }) => ({
    ...state,
    stats: makeStats(payload.stats)
  }),
  [FETCH_BROKER_PERFORMANCE_STATS_BEGIN]: state => ({
    ...state,
    loading: true
  }),
  [FETCH_BROKER_PERFORMANCE_STATS_END]: state => ({
    ...state,
    loading: false
  })
}, cleanState())
